export default {
  baseUrl: process.env.VUE_APP_BACKEND_URL || window.location.origin,
  epdpApiUrl: process.env.VUE_APP_EPDPAPI_URL || "http://localhost:5003",
  assessmentRubricsUrl:
    "http://www.binus.edu/innovation-award/post/top-3-assessment-rubrics/",
  posterTemplateUrl: "/uploads/PosterTemplateA2.pdf",
  /**
   * Dikarenakan permintaan untuk edit proposal,
   * dan peserta tidak boleh mengubah beberapa detil proposal,
   * maka beberapa component di disable
   */
  disableSomeComponents:
    (process.env.VUE_APP_DISABLE_SOME_COMPONENTS &&
      process.env.VUE_APP_DISABLE_SOME_COMPONENTS.toLowerCase() === "true") ||
    false,
};
